import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Root from "../Root.vue";
import NotFoundPage from "../components/views/404Page.vue";
import PlatMapPreview from "../components/views/PlatMapPreview.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/sales",
    component: Root,
    props: { mode: "sales", showSelectionDropdown: true },
  },
  {
    path: "/sales/:areaCode/:neighborhoodCode",
    component: Root,
    props: { mode: "sales", showSelectionDropdown: true },
  },
  {
    path: "/land",
    component: () => Root,
    props: { mode: "land", showSelectionDropdown: true },
  },
  {
    path: "/:areaName/:cityStateName/:communityName/plat",
    component: Root,
    // Without this the customer plat renders with mode === undefined, so every
    // `mode === 'customer'` branch silently takes the sales path (wrong lot colours).
    props: { mode: "customer" },
  },
  {
    path: "/sales-plat/preview",
    component: PlatMapPreview,
  },
  {
    path: "/:pathMatch(.*)*",
    component: NotFoundPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
